import TableBody from 'mrf/view/TableBody';
import T from 'mrf/utils/T';
import React from 'react';
import { StyledCell, StyledRow, StyledTable } from 'styles/components/Table.styles';
import IF from 'mrf/view/IF';
import { useTranslation } from 'react-i18next';

const flatten = (data, key) => {
    if (!(key instanceof Array))
        key = [key];

    return key.reduce((prev, curr) => prev?.[curr], data);
};

const FieldRenderer = ({ data, field }) => {
    const { t } = useTranslation();
    let fieldValue = flatten(data, field.key);
    
    if (field.keys){
        fieldValue = flatten(data, field.keys);
    }

    if (field.render) {
        fieldValue = field.render?.(fieldValue);
    }

    if (field.map) {
        fieldValue = field.map?.(fieldValue);
    }

    if (field.translate) {
        fieldValue = t(fieldValue);
    }

    return (
    <StyledRow>
        <StyledCell><T>{field.name}</T></StyledCell>
        <StyledCell className='flex'>
            {fieldValue}
        </StyledCell>
    </StyledRow>);
};

const ViewTable = ({ data, fields }) => (
    <StyledTable>
        <TableBody>
            {fields.map((field, idx) => (<IF condition={!field.hide}>
                <FieldRenderer
                    key={`${idx}-${field.name}`}
                    data={data}
                    field={field}
                />
            </IF>))}
        </TableBody>
    </StyledTable>
);

export default ViewTable;
